import React, { memo } from "react";
import cn from "clsx";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { helmetJsonLdProp } from "react-schemaorg";

import { useAppSelector } from "@/redux/store";

import BreadcrumbList from "../../../components/breadcrumbsList";
import {
  selectMapProductsUrl,
  selectPDPProductInfo,
  selectProductParents,
  selectProductTitleData,
  selectProductURL
} from "../selectors";
import { useIsRTL, useRouteSlug } from "../../../hooks";
import { getSEOStructuredBreadcrumbs } from "../../../util/seo";
import "./style.scss";

const ProductDetailsBreadcrumbs = () => {
  const { t } = useTranslation("breadcrumbs");
  const routeSlug = useRouteSlug();
  const { parentCategory, category, subcategory } =
    useAppSelector(selectProductParents);
  const parentsUrl = useAppSelector(selectMapProductsUrl);
  const productTitleData = useAppSelector(selectProductTitleData);
  const productURL = useAppSelector(selectProductURL);
  const meta = useAppSelector(state => state.seo.meta);

  const { productId } = useAppSelector(selectPDPProductInfo);
  const isRTL = useIsRTL();

  const breadcrumbs = [
    {
      id: "home",
      name: t("home"),
      url: `/${routeSlug}/`
    },
    ...[parentCategory, category, subcategory].map(breadcrumbDataItem => ({
      id: breadcrumbDataItem.key + breadcrumbDataItem.id,
      name: breadcrumbDataItem.label,
      url: `/${routeSlug}/${parentsUrl.get(breadcrumbDataItem)}`
    })),
    {
      id: `${productId}`,
      name: productTitleData?.label?.replace(/,/g, "")?.replace(/\//g, " "),
      url: `/${routeSlug}/${productURL}`
    }
  ];

  const seoStructuredBreadcrumbs = getSEOStructuredBreadcrumbs(
    breadcrumbs.map(breadcrumb => ({
      name: breadcrumb.name,
      url: breadcrumb.url
    }))
  );

  return (
    <>
      {meta?.isIndexable && (
        <Helmet script={[helmetJsonLdProp(seoStructuredBreadcrumbs as any)]} />
      )}
      <div className={cn("breadcrumb", { arabic: isRTL })}>
        <div className="container">
          <BreadcrumbList breadcrumbs={breadcrumbs} />
        </div>
      </div>
    </>
  );
};

export default memo(ProductDetailsBreadcrumbs);
